module.exports = __webpack_public_path__ + "static/media/customers.45623c6d.svg";